export default __webpack_public_path__ + "static/media/ambassador_nicola_nagyova.ea0067f2.jpg";